import { AnyAction, combineReducers } from 'redux'
import { createReducer } from '@cbgms/base/utils/redux'
import * as types from './types'
import order from 'lodash/orderBy'
import { IWholesalerOrderSystem, IWholesalerSupport } from '@cbgms/api'

const list = (state = [], action: AnyAction) => {
  switch (action.type) {
    case types.LOAD_WHOLESALERS_SUCCESS:
      return order(action.payload.data.Data, ['IsActive', 'UpdatedAt'], ['desc', 'desc'])
    default:
      return state
  }
}

const defaultDetailGeneral: Partial<IWholesalerSupport> = {
  IsActive: true
}

const detailGeneral = (state = defaultDetailGeneral, action: AnyAction) => {
  switch (action.type) {
    case types.LOAD_WHOLESALER_SUCCESS:
      return action.payload.data.Data as IWholesalerSupport
    case types.CLEAR_WHOLESALER:
      return defaultDetailGeneral
    default:
      return state
  }
}

const detailServices = createReducer([], {
  [types.LOAD_WHOLESALER_SERVICES_SUCCESS]: (_, { payload }) => {
    return payload.data.Data
  }
})

const defaultOrderSystems: IWholesalerOrderSystem[] = []

const ordersystems = (state = defaultOrderSystems, action: AnyAction) => {
  switch (action.type) {
    case types.LOAD_WHOLESALER_ORDERSYSTEMS_SUCCESS:
      return action.payload.data.Data as IWholesalerOrderSystem[]
    default:
      return state
  }
}

const detail = combineReducers({
  general: detailGeneral,
  services: detailServices
})

const wholesale = combineReducers({
  list,
  detail,
  ordersystems
})

export default wholesale
